import {createSlice} from "@reduxjs/toolkit";

export const viewModeSlice = createSlice({
    name: 'viewMode',
    initialState: {
        viewMode: 'edit', // default mode is 'edit'
    },
    reducers: {
        setViewMode: (state, action) => {
            state.viewMode = action.payload; // update the view mode
        },
    },
})


export const {setViewMode} = viewModeSlice.actions;
export default viewModeSlice.reducer;